// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"4c3be963","518":"18a219bb","543":"40cf2b9c","750":"ec3116d2","825":"d951f691"}[chunkId] + ".chunk.js";
};